import {
  faBolt,
  faNetworkWired,
  faPuzzlePiece,
} from "@fortawesome/free-solid-svg-icons";
import Footer from "../../../components/footer/Footer";
import Imagewheel from "../../../components/imagewheel/Imagewheel";
import Newsletter from "../../../components/newsletter/Newsletter";
import Walkthrough from "../../../components/walkthrough/Walkthrough";
import {
  PlanningFirstContainer,
  PlanningFirstImage,
  PlanningFirstIntroTitle,
  PlanningFirstLine,
  PlanningFirstText,
  PlanningFirstTextContainer,
  PlanningFirstTitle,
  PlanningPageContainer,
  PlanningSecondCard,
  PlanningSecondCardIcon,
  PlanningSecondCardsContainer,
  PlanningSecondCardText,
  PlanningSecondCardTitle,
  PlanningSecondContainer,
  PlanningSecondIntroTitle,
  PlanningSecondTextContainer,
  PlanningSecondTitle,
  PlanningThirdWalkthrough,
} from "./PlanningStyles";

function Planning() {
  const images = ["/assets/4.jpg", "/assets/5.jpg", "/assets/8.jpg"];

  return (
    <PlanningPageContainer>
      {/* Commissioners - Planning: Imagewheel */}
      <Imagewheel images={images} isPlanning={true} />

      {/* Commissioners - Planning: First Section */}
      <PlanningFirstContainer>
        <PlanningFirstImage src="/assets/20.jpg" alt="Smart Personeel" />
        <PlanningFirstTextContainer>
          <PlanningFirstIntroTitle>
            Smart Planning: Planners voor zorginstellingen
          </PlanningFirstIntroTitle>
          <PlanningFirstTitle>
            Slim gepland, zorg gegarandeerd
          </PlanningFirstTitle>
          <PlanningFirstText>
            Wat als je zorgplanner plotseling ziek wordt, met verlof gaat of
            onverwacht vertrekt?
          </PlanningFirstText>
          <PlanningFirstText>
            Zo’n situatie kan de continuïteit van zorg snel in gevaar brengen.
            Met Smart-Personeel heb je altijd een slimme oplossing binnen
            handbereik. Onze ervaren zorgplanners springen direct in en zorgen
            ervoor dat de planning soepel blijft verlopen, zonder lange
            inwerktijd.
          </PlanningFirstText>
          <PlanningFirstText>
            Onze planners hebben ervaring in verschillende zorgsectoren, zoals
            de thuiszorg, GGZ en GHZ. Ze nemen roosters, capaciteitsplanning en
            ad-hoc vervangingen moeiteloos over en maken zich snel de werkwijze
            van jouw organisatie eigen. Zo blijft de zorg draaien en kun jij met
            vertrouwen verder.
          </PlanningFirstText>
          <PlanningFirstLine />
        </PlanningFirstTextContainer>
      </PlanningFirstContainer>

      {/* Commissioners - Planning: Second Section */}
      <PlanningSecondContainer>
        <PlanningSecondTextContainer>
          <PlanningSecondIntroTitle>
            De kracht van Smart Planning
          </PlanningSecondIntroTitle>
          <PlanningSecondTitle>
            Slimme oplossingen voor uw zorgplanning
          </PlanningSecondTitle>
        </PlanningSecondTextContainer>
        <PlanningSecondCardsContainer>
          <PlanningSecondCard>
            <PlanningSecondCardIcon icon={faPuzzlePiece} />
            <PlanningSecondCardTitle>
              Maatwerkoplossingen
            </PlanningSecondCardTitle>
            <PlanningSecondCardText>
              Wij leveren zorgprofessionals die precies passen bij de specifieke
              behoeften van uw organisatie.
            </PlanningSecondCardText>
          </PlanningSecondCard>

          <PlanningSecondCard>
            <PlanningSecondCardIcon icon={faBolt} />
            <PlanningSecondCardTitle>Snelheid</PlanningSecondCardTitle>
            <PlanningSecondCardText>
              Snel de juiste planner aan boord, zodat je zorgteam weer volledig
              operationeel is.
            </PlanningSecondCardText>
          </PlanningSecondCard>

          <PlanningSecondCard>
            <PlanningSecondCardIcon icon={faNetworkWired} />
            <PlanningSecondCardTitle>
              Naadloze Integratie
            </PlanningSecondCardTitle>
            <PlanningSecondCardText>
              Onze zorgprofessionals passen zich snel aan en werken moeiteloos
              binnen uw organisatie
            </PlanningSecondCardText>
          </PlanningSecondCard>
        </PlanningSecondCardsContainer>
      </PlanningSecondContainer>

      {/* Commissioners - Planning: Third Section */}
      <PlanningThirdWalkthrough>
        <Walkthrough page="planning" />
      </PlanningThirdWalkthrough>

      {/* Commissioners - Planning: Newsletter */}
      <Newsletter />

      {/* Commissioners - Planning: Footer */}
      <Footer />
    </PlanningPageContainer>
  );
}

export default Planning;
